import { useMemo } from 'react';
import { useWatchableValue } from '@cotera/client/v0/actions/framework';
import { useWorkflowModel } from '../workflow.model';
import {
  workflowStructureIssues,
  type WorkflowStructureIssuesByNodeId,
} from '../workflow-structure-issues';

const NO_ISSUES: WorkflowStructureIssuesByNodeId = new Map();

/**
 * Structural warnings for every node in the open graph, for the marks on their
 * cards. Computed once at the canvas from the graph alone — no samples, no
 * fetches — and read per node out of context, mirroring `useWorkflowRefIssues`.
 */
export function useWorkflowStructureIssues(): WorkflowStructureIssuesByNodeId {
  const model = useWorkflowModel();
  const graph = useWatchableValue(model.graphWatchable);

  return useMemo(() => {
    if (graph === null) {
      return NO_ISSUES;
    }
    const issues = workflowStructureIssues(graph);
    return issues.size === 0 ? NO_ISSUES : issues;
  }, [graph]);
}
